import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const statisticsApi = createApi({
    reducerPath: 'statisticsApi',
    tagTypes: ['statistics'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getBookingsStatistics: build.query({
            query: ({id, ...data}) => ({
                url: api.statistics.getBookingsStatistics(),
                method: 'GET',
                params: data
            }),
        }),
    })
})

export const {useLazyGetBookingsStatisticsQuery} = statisticsApi
